import { session } from '@/utils/storage'

/**
 * Remembers the full dashboard URL (path + params) the user was trying to reach
 * when their session turned out to be gone, so the sign-in form can send them
 * there instead of dropping them on the home page.
 */

const STORAGE_KEY = 'redirect-after-login'

const AUTH_PATHS = ['/sign-in', '/sign-up', '/forgot-password']

/** Only in-app, non-auth targets are worth restoring. */
const isRestorablePath = (path: string) =>
  path.startsWith('/') &&
  !path.startsWith('//') &&
  path !== '/' &&
  !AUTH_PATHS.some(
    (authPath) => path === authPath || path.startsWith(`${authPath}?`)
  )

export const getCurrentAppPath = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`

export const rememberRedirectAfterLogin = (path: string) => {
  if (!isRestorablePath(path)) return
  session.saveState(STORAGE_KEY, path)
}

export const clearRedirectAfterLogin = () => {
  sessionStorage.removeItem(STORAGE_KEY)
}

/** Returns the remembered target once, then forgets it. */
export const consumeRedirectAfterLogin = (): string | null => {
  const path = session.loadState(STORAGE_KEY)
  clearRedirectAfterLogin()
  return typeof path === 'string' && isRestorablePath(path) ? path : null
}
